import React, { Component } from 'react'
import NavMenu from './NavMenu'
import { connect } from 'react-redux'

class MainLayout extends Component {
	render() {
		const { loggedIn } = this.props
		return (
			<div>
				{loggedIn && <NavMenu />}
				
				{this.props.children}
			</div>
		)
	}
}

function mapStateToProps(state) {
	const { loggedIn } = state.authentication
	return {
		loggedIn,
	}
}

export default connect(mapStateToProps)(MainLayout)
